import type { FaireProductEntity } from "../../entity_types/product";

export const p_5yknracpz6: FaireProductEntity = {
  token: "p_5yknracpz6",
  type: "product",
  name: "B3780-A967 FLORAL PRINT WRAP PANTS",
  brandToken: "b_dkldnd6ff4",
  brandName: "ANGIE",
  imageUrl:
    "https://cdn.faire.com/fastly/a7a8d9ae46638ac83020d5701f64a0a8c0780e6e0744ece588e24f5023306867.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd4d14dd21f6647e02011f6ef430980a56708964d14eca2bc526e5f36dcca0c4.jpeg",
    "https://cdn.faire.com/fastly/1375eef58def863e0c71b7d2e4557269926ab722a2f84a582105d4e87b426edc.jpeg",
    "https://cdn.faire.com/fastly/c9cff4b6485e7738c3ce9967b87d0efbb7dfaa7a3c514ee7857ba7e319846869.jpeg",
    "https://cdn.faire.com/fastly/d274414f0bd4ad3ecbd92818a720b649c7b1012eefff3b6e9da905720066aa70.jpeg",
    "https://cdn.faire.com/fastly/2460d69da0e2b8b9b0c68a1029a0fbbd257c9320ec69e9830d47f60bcfc60584.jpeg",
  ],
  priceDollars: 162.13,
  description:
    "The Angie B3780-A967 Floral Print Wrap Pants, a part of our bohemian-inspired collection, are an ideal blend of comfort and style. Designed with a classic, regular fit, these pants are perfect for everyday wear or for that special resort vacation. The pants feature a beautiful floral print, a chic wide-leg silhouette, and an eye-catching slit detail. Made of Rayon, they offer a soft, lightweight feel. These ankle-length, junior-sized pants are not just functional but also bring a touch of flair to your wardrobe. Embrace the well-traveled, romantic spirit of Angie with these standout wrap pants.",
  tags: [],
  msrpDollars: 324.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:38.951Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
